import React from 'react';
import { formatRupiah } from './trackingHelpers';
import { formatWeightKg, shippingFeeLabel } from './orderDisplayHelpers';

// Use in the existing top summary's Ongkir value slot. Does not calculate money.
export default function ShippingSummaryValue({ amount, shipping }) {
  return <>
    <span>{shippingFeeLabel(shipping?.fee_state, amount, formatRupiah)}</span>
    {shipping?.weight_complete === true && typeof shipping.total_weight_kg === 'number' && shipping.total_weight_kg > 0 &&
      <span className="wx-shipping-summary-weight">{formatWeightKg(shipping.total_weight_kg)}</span>}
    {shipping?.active_package_count > 0 && shipping?.weight_complete !== true &&
      <span className="wx-shipping-summary-weight">Berat belum lengkap</span>}
  </>;
}
